document.addEventListener('DOMContentLoaded', () => {
  const tooltip = document.createElement('div');
  tooltip.id = 'header-tooltip';
  tooltip.style.cssText = `
    position: fixed;
    background-color: #222;
    color: #fff;
    font-size: 11px;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
    pointer-events: none;
    z-index: 9999;
    opacity: 0;
    transition: opacity 0.2s ease;
  `;
  document.body.appendChild(tooltip);

  const cartIcon = document.getElementById('cart-icon-bubble');

  // Update cart tooltip based on cart count bubble presence
  function updateCartTooltip() {
    const hasBubble = cartIcon && cartIcon.querySelector('.cart-count-bubble');
    if (cartIcon) {
      cartIcon.dataset.tooltip = hasBubble ? 'My Bowl' : 'Bowl Empty';
    }
  }

  // Watch for cart bubble changes (AJAX cart updates)
  const observer = new MutationObserver(updateCartTooltip);
  if (cartIcon) {
    observer.observe(cartIcon, { childList: true, subtree: true });
  }

  updateCartTooltip();

  const icons = document.querySelectorAll('[data-tooltip]');
  icons.forEach(icon => {
    icon.addEventListener('mouseenter', () => {
      const rect = icon.getBoundingClientRect();
      tooltip.textContent = icon.dataset.tooltip;
      tooltip.style.opacity = '1';
      tooltip.style.left = (rect.left + rect.width / 2 - tooltip.offsetWidth / 2) + 'px';
      tooltip.style.top = (rect.bottom + 8) + 'px';
    });

    icon.addEventListener('mouseleave', () => {
      tooltip.style.opacity = '0';
    });
  });
});
